export default "__VITE_ASSET__88efc73f__"